import { render, staticRenderFns } from "./LiquidacaoListNivel2.vue?vue&type=template&id=8a00d9c4&"
import script from "./LiquidacaoListNivel2.vue?vue&type=script&lang=js&"
export * from "./LiquidacaoListNivel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports